import React from "react";
import useFetch from "@/lib/useFetch";
import { useAdmin } from "@/context/AdminContext";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";
import StatusBadge from "@/components/common/StatusBadge";
import { themeFor } from "@/lib/communities";
import { Users, Gamepad2, Flame } from "lucide-react";

export default function Communities() {
    const { community } = useAdmin();
    const { data } = useFetch("/communities");
    if (!data) return <Loader />;
    const shown = community === "ALL" ? data : data.filter((c) => c.key === community);

    return (
        <div data-testid="admin-communities">
            <PageHeader title="Communities" subtitle="Manage your Rust communities. Add more anytime." />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
                {shown.map((c) => {
                    const t = themeFor(c);
                    return (
                        <div key={c.key} className="tactical-card rounded-lg p-5" style={{ borderTop: `3px solid ${t.accent}` }}>
                            <div className="flex items-center justify-between">
                                <h3 className="font-heading text-xl font-bold uppercase text-foreground">{c.name}</h3>
                                {c.has_purge && <StatusBadge status="wiping" label="PURGE" />}
                            </div>
                            <div className="label-mono text-muted-foreground mt-1">{c.key}</div>
                            <p className="text-sm text-muted-foreground mt-2">{c.platform} · {c.mode}</p>
                            <div className="grid grid-cols-3 gap-2 mt-4">
                                <Stat icon={Gamepad2} label="Online" value={c.players_online} accent={t.accent} />
                                <Stat icon={Users} label="Members" value={c.members} accent={t.accent} />
                                <Stat icon={Flame} label="Cap" value={c.max_players} accent={t.accent} />
                            </div>
                            <div className="mt-3 label-mono text-muted-foreground">Discord Role: <span className="text-foreground">{c.discord_role}</span></div>
                        </div>
                    );
                })}
            </div>
            <Footer />
        </div>
    );
}

function Stat({ icon: Icon, label, value, accent }) {
    return (
        <div className="rounded-md border border-border bg-background/40 p-2.5 text-center">
            <Icon size={15} className="mx-auto mb-1" style={{ color: accent }} />
            <div className="font-heading text-lg font-bold text-foreground">{value}</div>
            <div className="label-mono text-muted-foreground">{label}</div>
        </div>
    );
}
